import helpers from "../utils/helpers";

const singlePost = {
  init: function () {
    this.events();
  },

  events: function () {
    var related = $(".news__slider");
    related.slick({
      slidesToShow: 3,
      prevArrow:
        '<button class="slick-prev" aria-label="prev"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="10" viewBox="0 0 16 10"> <defs> <polygon id="arrow-left-a" points="18 15 12 20.06 18 25 18 21 28 21 28 19 18 19"></polygon> </defs> <use transform="translate(-12 -15)" xlink:href="#arrow-left-a"></use></svg></button>',
      nextArrow:
        '<button class="slick-next" aria-label="next"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="10" viewBox="0 0 16 10"> <defs> <polygon id="arrow-right-a" points="18 15 12 20.06 18 25 18 21 28 21 28 19 18 19"></polygon> </defs> <use transform="rotate(-180 14 12.5)" xlink:href="#arrow-right-a"></use></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    if ($(".soc-share").length) {
      $("body").on("click", ".soc-share", function (e) {
        e.preventDefault();

        var platform = $(this).attr("data-platform");
        var data = $(this).attr("data-content");

        helpers.share(platform, data);
      });
    }
  },
};

export default singlePost;
